import script from "./UserBalances.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserBalances.vue?vue&type=script&setup=true&lang=ts"

import "./UserBalances.vue?vue&type=style&index=0&id=165491dc&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-165491dc"]])

export default __exports__